/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import * as moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.INVENTORY_SERVICE_URL) {
      throw new Error('INVENTORY_SERVICE_URL must be set in environment');
    }

    return process.env.INVENTORY_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class ServiceTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-inventory-dev.sekoia.one", baseUrl);
    }

    createServiceType(request: CreateServiceTypeRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/serviceTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateServiceType(_response);
        });
    }

    protected processCreateServiceType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getServiceTypes(signal?: AbortSignal, headers?: HeadersInit): Promise<ServiceTypeResponse[]> {
        let url_ = this.baseUrl + "/api/inventory/serviceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServiceTypes(_response);
        });
    }

    protected processGetServiceTypes(response: Response): Promise<ServiceTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceTypeResponse[]>(<any>null);
    }

    deleteServiceType(serviceTypeId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/serviceTypes/{serviceTypeId}";
        if (serviceTypeId === undefined || serviceTypeId === null)
            throw new Error("The parameter 'serviceTypeId' must be defined.");
        url_ = url_.replace("{serviceTypeId}", encodeURIComponent("" + serviceTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteServiceType(_response);
        });
    }

    protected processDeleteServiceType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-inventory-dev.sekoia.one", baseUrl);
    }

    createProduct(request: CreateProductRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateProduct(_response);
        });
    }

    protected processCreateProduct(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteProduct(productId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/product/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteProduct(_response);
        });
    }

    protected processDeleteProduct(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateProduct(productId: string, request: UpdateProductRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/product/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProduct(_response);
        });
    }

    protected processUpdateProduct(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    undeleteProduct(productId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/product/{productId}/undelete";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUndeleteProduct(_response);
        });
    }

    protected processUndeleteProduct(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-inventory-dev.sekoia.one", baseUrl);
    }

    createProductType(request: CreateProductTypeRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/productType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateProductType(_response);
        });
    }

    protected processCreateProductType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteProductType(productTypeId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/productType/{productTypeId}";
        if (productTypeId === undefined || productTypeId === null)
            throw new Error("The parameter 'productTypeId' must be defined.");
        url_ = url_.replace("{productTypeId}", encodeURIComponent("" + productTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteProductType(_response);
        });
    }

    protected processDeleteProductType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateProductType(productTypeId: string, request: UpdateProductTypeRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/productType/{productTypeId}";
        if (productTypeId === undefined || productTypeId === null)
            throw new Error("The parameter 'productTypeId' must be defined.");
        url_ = url_.replace("{productTypeId}", encodeURIComponent("" + productTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProductType(_response);
        });
    }

    protected processUpdateProductType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    undeleteProductType(productTypeId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/productType/{productTypeId}/undelete";
        if (productTypeId === undefined || productTypeId === null)
            throw new Error("The parameter 'productTypeId' must be defined.");
        url_ = url_.replace("{productTypeId}", encodeURIComponent("" + productTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUndeleteProductType(_response);
        });
    }

    protected processUndeleteProductType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductCategoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-inventory-dev.sekoia.one", baseUrl);
    }

    createProductCategory(request: CreateProductCategoryRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/productCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateProductCategory(_response);
        });
    }

    protected processCreateProductCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getProductCategories(signal?: AbortSignal, headers?: HeadersInit): Promise<ProductCategoryResponse[]> {
        let url_ = this.baseUrl + "/api/inventory/productCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductCategories(_response);
        });
    }

    protected processGetProductCategories(response: Response): Promise<ProductCategoryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductCategoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductCategoryResponse[]>(<any>null);
    }

    deleteProductCategory(productCategoryId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/productCategory/{productCategoryId}";
        if (productCategoryId === undefined || productCategoryId === null)
            throw new Error("The parameter 'productCategoryId' must be defined.");
        url_ = url_.replace("{productCategoryId}", encodeURIComponent("" + productCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteProductCategory(_response);
        });
    }

    protected processDeleteProductCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateProductCategory(productCategoryId: string, request: UpdateProductCategoryRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/productCategory/{productCategoryId}";
        if (productCategoryId === undefined || productCategoryId === null)
            throw new Error("The parameter 'productCategoryId' must be defined.");
        url_ = url_.replace("{productCategoryId}", encodeURIComponent("" + productCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProductCategory(_response);
        });
    }

    protected processUpdateProductCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    undeleteProductCategory(productCategoryId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/productCategory/{productCategoryId}/undelete";
        if (productCategoryId === undefined || productCategoryId === null)
            throw new Error("The parameter 'productCategoryId' must be defined.");
        url_ = url_.replace("{productCategoryId}", encodeURIComponent("" + productCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUndeleteProductCategory(_response);
        });
    }

    protected processUndeleteProductCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class InventoryItemClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-inventory-dev.sekoia.one", baseUrl);
    }

    createInventoryItem(request: CreateInventoryItemRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateInventoryItem(_response);
        });
    }

    protected processCreateInventoryItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getInventoryItems(organisationId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<InventoryItemResponse[]> {
        let url_ = this.baseUrl + "/api/inventory/items/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryItems(_response);
        });
    }

    protected processGetInventoryItems(response: Response): Promise<InventoryItemResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryItemResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryItemResponse[]>(<any>null);
    }

    getInventoryItemDetails(inventoryItemId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<InventoryItemDetailsResponse> {
        let url_ = this.baseUrl + "/api/inventory/items/{inventoryItemId}/details";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryItemDetails(_response);
        });
    }

    protected processGetInventoryItemDetails(response: Response): Promise<InventoryItemDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InventoryItemDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryItemDetailsResponse>(<any>null);
    }

    updateInventoryItem(request: UpdateInventoryItemRequest, inventoryItemId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/items/{inventoryItemId}";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateInventoryItem(_response);
        });
    }

    protected processUpdateInventoryItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteInventoryItem(request: DeleteInventoryItemRequest, inventoryItemId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/items/{inventoryItemId}";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInventoryItem(_response);
        });
    }

    protected processDeleteInventoryItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateInventoryItemStatus(inventoryItemId: string, inventoryItemStatus: InventoryItemStatus, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/items/{inventoryItemId}/status/{inventoryItemStatus}";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        if (inventoryItemStatus === undefined || inventoryItemStatus === null)
            throw new Error("The parameter 'inventoryItemStatus' must be defined.");
        url_ = url_.replace("{inventoryItemStatus}", encodeURIComponent("" + inventoryItemStatus));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateInventoryItemStatus(_response);
        });
    }

    protected processUpdateInventoryItemStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    startLendingPeriod(inventoryItemId: string, request: StartLendingPeriodRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/items/{inventoryItemId}/startLendingPeriod";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartLendingPeriod(_response);
        });
    }

    protected processStartLendingPeriod(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    addInventoryItemService(inventoryItemId: string, request: AddInventoryItemServiceRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/items/{inventoryItemId}/service";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddInventoryItemService(_response);
        });
    }

    protected processAddInventoryItemService(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getInventoryItemServices(inventoryItemId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<InventoryItemServiceResponse[]> {
        let url_ = this.baseUrl + "/api/inventory/items/{inventoryItemId}/services";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryItemServices(_response);
        });
    }

    protected processGetInventoryItemServices(response: Response): Promise<InventoryItemServiceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryItemServiceResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryItemServiceResponse[]>(<any>null);
    }

    getLoanHistory(inventoryItemId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<LoanHistoryLendingPeriodResponse[]> {
        let url_ = this.baseUrl + "/api/inventory/items/{inventoryItemId}/loanHistory";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoanHistory(_response);
        });
    }

    protected processGetLoanHistory(response: Response): Promise<LoanHistoryLendingPeriodResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LoanHistoryLendingPeriodResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoanHistoryLendingPeriodResponse[]>(<any>null);
    }

    getInventoryItemsForResidentWithLatestLendingPeriod(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<InventoryItemWithLatestLendingPeriodForResidentResponse[]> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/inventory/items/latestLendingPeriod";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryItemsForResidentWithLatestLendingPeriod(_response);
        });
    }

    protected processGetInventoryItemsForResidentWithLatestLendingPeriod(response: Response): Promise<InventoryItemWithLatestLendingPeriodForResidentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryItemWithLatestLendingPeriodForResidentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryItemWithLatestLendingPeriodForResidentResponse[]>(<any>null);
    }

    unDeleteInventoryItem(inventoryItemId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/items/{inventoryItemId}/undelete";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnDeleteInventoryItem(_response);
        });
    }

    protected processUnDeleteInventoryItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class InventoryItemSourceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-inventory-dev.sekoia.one", baseUrl);
    }

    createInventoryItemSource(request: CreateInventoryItemSourceRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/items/sources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateInventoryItemSource(_response);
        });
    }

    protected processCreateInventoryItemSource(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getInventoryItemSources(signal?: AbortSignal, headers?: HeadersInit): Promise<InventoryItemSourceResponse[]> {
        let url_ = this.baseUrl + "/api/inventory/items/sources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryItemSources(_response);
        });
    }

    protected processGetInventoryItemSources(response: Response): Promise<InventoryItemSourceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InventoryItemSourceResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryItemSourceResponse[]>(<any>null);
    }

    deleteInventoryItemSource(inventoryItemSourceId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/inventory/items/sources/{inventoryItemSourceId}";
        if (inventoryItemSourceId === undefined || inventoryItemSourceId === null)
            throw new Error("The parameter 'inventoryItemSourceId' must be defined.");
        url_ = url_.replace("{inventoryItemSourceId}", encodeURIComponent("" + inventoryItemSourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInventoryItemSource(_response);
        });
    }

    protected processDeleteInventoryItemSource(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class CreateServiceTypeRequest implements ICreateServiceTypeRequest {
    name!: string;

    constructor(data?: ICreateServiceTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateServiceTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface ICreateServiceTypeRequest {
    name: string;
}

export class ServiceTypeResponse implements IServiceTypeResponse {
    id!: string;
    name!: string;

    constructor(data?: IServiceTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface IServiceTypeResponse {
    id: string;
    name: string;
}

export class CreateProductRequest implements ICreateProductRequest {
    productTypeId!: string;
    name!: string;
    manufacturer!: string;
    description?: string | null;

    constructor(data?: ICreateProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productTypeId = _data["productTypeId"] !== undefined ? _data["productTypeId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.manufacturer = _data["manufacturer"] !== undefined ? _data["manufacturer"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): CreateProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productTypeId"] = this.productTypeId !== undefined ? this.productTypeId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data; 
    }
}

export interface ICreateProductRequest {
    productTypeId: string;
    name: string;
    manufacturer: string;
    description?: string | null;
}

export class UpdateProductRequest implements IUpdateProductRequest {
    name!: string;
    manufacturer!: string;
    description?: string | null;

    constructor(data?: IUpdateProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.manufacturer = _data["manufacturer"] !== undefined ? _data["manufacturer"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data; 
    }
}

export interface IUpdateProductRequest {
    name: string;
    manufacturer: string;
    description?: string | null;
}

export class CreateProductTypeRequest implements ICreateProductTypeRequest {
    name!: string;
    productCategoryId!: string;
    actIds!: string[];

    constructor(data?: ICreateProductTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.actIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.productCategoryId = _data["productCategoryId"] !== undefined ? _data["productCategoryId"] : <any>null;
            if (Array.isArray(_data["actIds"])) {
                this.actIds = [] as any;
                for (let item of _data["actIds"])
                    this.actIds!.push(item);
            }
            else {
                this.actIds = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateProductTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["productCategoryId"] = this.productCategoryId !== undefined ? this.productCategoryId : <any>null;
        if (Array.isArray(this.actIds)) {
            data["actIds"] = [];
            for (let item of this.actIds)
                data["actIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateProductTypeRequest {
    name: string;
    productCategoryId: string;
    actIds: string[];
}

export class UpdateProductTypeRequest implements IUpdateProductTypeRequest {
    name!: string;
    actIds!: string[];

    constructor(data?: IUpdateProductTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.actIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["actIds"])) {
                this.actIds = [] as any;
                for (let item of _data["actIds"])
                    this.actIds!.push(item);
            }
            else {
                this.actIds = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateProductTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.actIds)) {
            data["actIds"] = [];
            for (let item of this.actIds)
                data["actIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateProductTypeRequest {
    name: string;
    actIds: string[];
}

export class CreateProductCategoryRequest implements ICreateProductCategoryRequest {
    name!: string;

    constructor(data?: ICreateProductCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateProductCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface ICreateProductCategoryRequest {
    name: string;
}

export class ProductCategoryResponse implements IProductCategoryResponse {
    id!: string;
    name!: string;
    isDeleted!: boolean;
    productTypes!: ProductTypeResponse[];

    constructor(data?: IProductCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            if (Array.isArray(_data["productTypes"])) {
                this.productTypes = [] as any;
                for (let item of _data["productTypes"])
                    this.productTypes!.push(ProductTypeResponse.fromJS(item));
            }
            else {
                this.productTypes = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        if (Array.isArray(this.productTypes)) {
            data["productTypes"] = [];
            for (let item of this.productTypes)
                data["productTypes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductCategoryResponse {
    id: string;
    name: string;
    isDeleted: boolean;
    productTypes: ProductTypeResponse[];
}

export class ProductTypeResponse implements IProductTypeResponse {
    id!: string;
    name!: string;
    isDeleted!: boolean;
    products!: ProductResponse[];
    accessControlTagIds!: string[];

    constructor(data?: IProductTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.products = [];
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductResponse.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IProductTypeResponse {
    id: string;
    name: string;
    isDeleted: boolean;
    products: ProductResponse[];
    accessControlTagIds: string[];
}

export class ProductResponse implements IProductResponse {
    id!: string;
    name!: string;
    isDeleted!: boolean;
    manufacturer!: string;
    description?: string | null;

    constructor(data?: IProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.manufacturer = _data["manufacturer"] !== undefined ? _data["manufacturer"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): ProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data; 
    }
}

export interface IProductResponse {
    id: string;
    name: string;
    isDeleted: boolean;
    manufacturer: string;
    description?: string | null;
}

export class UpdateProductCategoryRequest implements IUpdateProductCategoryRequest {
    name!: string;

    constructor(data?: IUpdateProductCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProductCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface IUpdateProductCategoryRequest {
    name: string;
}

export class CreateInventoryItemRequest implements ICreateInventoryItemRequest {
    productId!: string;
    assignedId!: string;
    organisationId!: string;
    productionYearMonth!: YearMonthRequest;
    purchaseYearMonth!: YearMonthRequest;
    sourceId!: string;

    constructor(data?: ICreateInventoryItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productionYearMonth = new YearMonthRequest();
            this.purchaseYearMonth = new YearMonthRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.assignedId = _data["assignedId"] !== undefined ? _data["assignedId"] : <any>null;
            this.organisationId = _data["organisationId"] !== undefined ? _data["organisationId"] : <any>null;
            this.productionYearMonth = _data["productionYearMonth"] ? YearMonthRequest.fromJS(_data["productionYearMonth"]) : new YearMonthRequest();
            this.purchaseYearMonth = _data["purchaseYearMonth"] ? YearMonthRequest.fromJS(_data["purchaseYearMonth"]) : new YearMonthRequest();
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateInventoryItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInventoryItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["assignedId"] = this.assignedId !== undefined ? this.assignedId : <any>null;
        data["organisationId"] = this.organisationId !== undefined ? this.organisationId : <any>null;
        data["productionYearMonth"] = this.productionYearMonth ? this.productionYearMonth.toJSON() : <any>null;
        data["purchaseYearMonth"] = this.purchaseYearMonth ? this.purchaseYearMonth.toJSON() : <any>null;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : <any>null;
        return data; 
    }
}

export interface ICreateInventoryItemRequest {
    productId: string;
    assignedId: string;
    organisationId: string;
    productionYearMonth: YearMonthRequest;
    purchaseYearMonth: YearMonthRequest;
    sourceId: string;
}

export class YearMonthRequest implements IYearMonthRequest {
    year!: number;
    month?: number | null;

    constructor(data?: IYearMonthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.month = _data["month"] !== undefined ? _data["month"] : <any>null;
        }
    }

    static fromJS(data: any): YearMonthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new YearMonthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["month"] = this.month !== undefined ? this.month : <any>null;
        return data; 
    }
}

export interface IYearMonthRequest {
    year: number;
    month?: number | null;
}

export class InventoryItemResponse implements IInventoryItemResponse {
    id!: string;
    productName!: string;
    productTypeName!: string;
    productCategoryName!: string;
    assignedId!: string;
    status!: InventoryItemStatus;
    accessControlTagIds!: string[];
    activeLendingPeriod?: LendingPeriodResponse | null;
    deletedAt?: moment.Moment | null;
    deletedReason?: string | null;
    deletedBy?: string | null;
    isDeleted!: boolean;

    constructor(data?: IInventoryItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
            this.productTypeName = _data["productTypeName"] !== undefined ? _data["productTypeName"] : <any>null;
            this.productCategoryName = _data["productCategoryName"] !== undefined ? _data["productCategoryName"] : <any>null;
            this.assignedId = _data["assignedId"] !== undefined ? _data["assignedId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.activeLendingPeriod = _data["activeLendingPeriod"] ? LendingPeriodResponse.fromJS(_data["activeLendingPeriod"]) : <any>null;
            this.deletedAt = _data["deletedAt"] ? moment(_data["deletedAt"].toString()) : <any>null;
            this.deletedReason = _data["deletedReason"] !== undefined ? _data["deletedReason"] : <any>null;
            this.deletedBy = _data["deletedBy"] !== undefined ? _data["deletedBy"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): InventoryItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        data["productTypeName"] = this.productTypeName !== undefined ? this.productTypeName : <any>null;
        data["productCategoryName"] = this.productCategoryName !== undefined ? this.productCategoryName : <any>null;
        data["assignedId"] = this.assignedId !== undefined ? this.assignedId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["activeLendingPeriod"] = this.activeLendingPeriod ? this.activeLendingPeriod.toJSON() : <any>null;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>null;
        data["deletedReason"] = this.deletedReason !== undefined ? this.deletedReason : <any>null;
        data["deletedBy"] = this.deletedBy !== undefined ? this.deletedBy : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        return data; 
    }
}

export interface IInventoryItemResponse {
    id: string;
    productName: string;
    productTypeName: string;
    productCategoryName: string;
    assignedId: string;
    status: InventoryItemStatus;
    accessControlTagIds: string[];
    activeLendingPeriod?: LendingPeriodResponse | null;
    deletedAt?: moment.Moment | null;
    deletedReason?: string | null;
    deletedBy?: string | null;
    isDeleted: boolean;
}

export enum InventoryItemStatus {
    Available = "Available",
    NotAvailable = "NotAvailable",
    OnLoan = "OnLoan",
    Discarded = "Discarded",
    UnderRepair = "UnderRepair",
    AtService = "AtService",
}

export class LendingPeriodResponse implements ILendingPeriodResponse {
    loanedOutToType!: LoanedOutToType;
    loanedOutToId?: string | null;
    startDate!: moment.Moment;
    endDate?: moment.Moment | null;
    accessoryDescription?: string | null;

    constructor(data?: ILendingPeriodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanedOutToType = _data["loanedOutToType"] !== undefined ? _data["loanedOutToType"] : <any>null;
            this.loanedOutToId = _data["loanedOutToId"] !== undefined ? _data["loanedOutToId"] : <any>null;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>null;
            this.accessoryDescription = _data["accessoryDescription"] !== undefined ? _data["accessoryDescription"] : <any>null;
        }
    }

    static fromJS(data: any): LendingPeriodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LendingPeriodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanedOutToType"] = this.loanedOutToType !== undefined ? this.loanedOutToType : <any>null;
        data["loanedOutToId"] = this.loanedOutToId !== undefined ? this.loanedOutToId : <any>null;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : <any>null;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : <any>null;
        data["accessoryDescription"] = this.accessoryDescription !== undefined ? this.accessoryDescription : <any>null;
        return data; 
    }
}

export interface ILendingPeriodResponse {
    loanedOutToType: LoanedOutToType;
    loanedOutToId?: string | null;
    startDate: moment.Moment;
    endDate?: moment.Moment | null;
    accessoryDescription?: string | null;
}

export enum LoanedOutToType {
    Resident = "Resident",
    Apartment = "Apartment",
    Department = "Department",
    Organisation = "Organisation",
}

export class InventoryItemDetailsResponse implements IInventoryItemDetailsResponse {
    id!: string;
    productName!: string;
    productTypeName!: string;
    productCategoryName!: string;
    assignedId!: string;
    productionYearMonth!: YearMonth;
    purchaseYearMonth!: YearMonth;
    status!: InventoryItemStatus;
    accessControlTagIds!: string[];
    source!: InventoryItemSourceResponse;
    deletedAt?: moment.Moment | null;
    deletedReason?: string | null;
    deletedBy?: string | null;
    isDeleted!: boolean;

    constructor(data?: IInventoryItemDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productionYearMonth = new YearMonth();
            this.purchaseYearMonth = new YearMonth();
            this.accessControlTagIds = [];
            this.source = new InventoryItemSourceResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
            this.productTypeName = _data["productTypeName"] !== undefined ? _data["productTypeName"] : <any>null;
            this.productCategoryName = _data["productCategoryName"] !== undefined ? _data["productCategoryName"] : <any>null;
            this.assignedId = _data["assignedId"] !== undefined ? _data["assignedId"] : <any>null;
            this.productionYearMonth = _data["productionYearMonth"] ? YearMonth.fromJS(_data["productionYearMonth"]) : new YearMonth();
            this.purchaseYearMonth = _data["purchaseYearMonth"] ? YearMonth.fromJS(_data["purchaseYearMonth"]) : new YearMonth();
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.source = _data["source"] ? InventoryItemSourceResponse.fromJS(_data["source"]) : new InventoryItemSourceResponse();
            this.deletedAt = _data["deletedAt"] ? moment(_data["deletedAt"].toString()) : <any>null;
            this.deletedReason = _data["deletedReason"] !== undefined ? _data["deletedReason"] : <any>null;
            this.deletedBy = _data["deletedBy"] !== undefined ? _data["deletedBy"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): InventoryItemDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        data["productTypeName"] = this.productTypeName !== undefined ? this.productTypeName : <any>null;
        data["productCategoryName"] = this.productCategoryName !== undefined ? this.productCategoryName : <any>null;
        data["assignedId"] = this.assignedId !== undefined ? this.assignedId : <any>null;
        data["productionYearMonth"] = this.productionYearMonth ? this.productionYearMonth.toJSON() : <any>null;
        data["purchaseYearMonth"] = this.purchaseYearMonth ? this.purchaseYearMonth.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["source"] = this.source ? this.source.toJSON() : <any>null;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>null;
        data["deletedReason"] = this.deletedReason !== undefined ? this.deletedReason : <any>null;
        data["deletedBy"] = this.deletedBy !== undefined ? this.deletedBy : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        return data; 
    }
}

export interface IInventoryItemDetailsResponse {
    id: string;
    productName: string;
    productTypeName: string;
    productCategoryName: string;
    assignedId: string;
    productionYearMonth: YearMonth;
    purchaseYearMonth: YearMonth;
    status: InventoryItemStatus;
    accessControlTagIds: string[];
    source: InventoryItemSourceResponse;
    deletedAt?: moment.Moment | null;
    deletedReason?: string | null;
    deletedBy?: string | null;
    isDeleted: boolean;
}

export class YearMonth implements IYearMonth {
    year!: number;
    month?: number | null;

    constructor(data?: IYearMonth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.month = _data["month"] !== undefined ? _data["month"] : <any>null;
        }
    }

    static fromJS(data: any): YearMonth {
        data = typeof data === 'object' ? data : {};
        let result = new YearMonth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["month"] = this.month !== undefined ? this.month : <any>null;
        return data; 
    }
}

export interface IYearMonth {
    year: number;
    month?: number | null;
}

export class InventoryItemSourceResponse implements IInventoryItemSourceResponse {
    id!: string;
    name!: string;

    constructor(data?: IInventoryItemSourceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): InventoryItemSourceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemSourceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface IInventoryItemSourceResponse {
    id: string;
    name: string;
}

export class UpdateInventoryItemRequest implements IUpdateInventoryItemRequest {
    assignedId!: string;
    productionYearMonth!: YearMonthRequest;
    purchaseYearMonth!: YearMonthRequest;
    sourceId!: string;

    constructor(data?: IUpdateInventoryItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productionYearMonth = new YearMonthRequest();
            this.purchaseYearMonth = new YearMonthRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedId = _data["assignedId"] !== undefined ? _data["assignedId"] : <any>null;
            this.productionYearMonth = _data["productionYearMonth"] ? YearMonthRequest.fromJS(_data["productionYearMonth"]) : new YearMonthRequest();
            this.purchaseYearMonth = _data["purchaseYearMonth"] ? YearMonthRequest.fromJS(_data["purchaseYearMonth"]) : new YearMonthRequest();
            this.sourceId = _data["sourceId"] !== undefined ? _data["sourceId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateInventoryItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInventoryItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedId"] = this.assignedId !== undefined ? this.assignedId : <any>null;
        data["productionYearMonth"] = this.productionYearMonth ? this.productionYearMonth.toJSON() : <any>null;
        data["purchaseYearMonth"] = this.purchaseYearMonth ? this.purchaseYearMonth.toJSON() : <any>null;
        data["sourceId"] = this.sourceId !== undefined ? this.sourceId : <any>null;
        return data; 
    }
}

export interface IUpdateInventoryItemRequest {
    assignedId: string;
    productionYearMonth: YearMonthRequest;
    purchaseYearMonth: YearMonthRequest;
    sourceId: string;
}

export class StartLendingPeriodRequest implements IStartLendingPeriodRequest {
    loanedOutToId!: string;
    loanedOutToType!: LoanedOutToType;
    startDate!: moment.Moment;
    endDate?: moment.Moment | null;
    accessoryDescription?: string | null;

    constructor(data?: IStartLendingPeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanedOutToId = _data["loanedOutToId"] !== undefined ? _data["loanedOutToId"] : <any>null;
            this.loanedOutToType = _data["loanedOutToType"] !== undefined ? _data["loanedOutToType"] : <any>null;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>null;
            this.accessoryDescription = _data["accessoryDescription"] !== undefined ? _data["accessoryDescription"] : <any>null;
        }
    }

    static fromJS(data: any): StartLendingPeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartLendingPeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanedOutToId"] = this.loanedOutToId !== undefined ? this.loanedOutToId : <any>null;
        data["loanedOutToType"] = this.loanedOutToType !== undefined ? this.loanedOutToType : <any>null;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : <any>null;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : <any>null;
        data["accessoryDescription"] = this.accessoryDescription !== undefined ? this.accessoryDescription : <any>null;
        return data; 
    }
}

export interface IStartLendingPeriodRequest {
    loanedOutToId: string;
    loanedOutToType: LoanedOutToType;
    startDate: moment.Moment;
    endDate?: moment.Moment | null;
    accessoryDescription?: string | null;
}

export class AddInventoryItemServiceRequest implements IAddInventoryItemServiceRequest {
    servicedAt!: moment.Moment;
    description?: string | null;
    serviceTypeId!: string;

    constructor(data?: IAddInventoryItemServiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servicedAt = _data["servicedAt"] ? moment(_data["servicedAt"].toString()) : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.serviceTypeId = _data["serviceTypeId"] !== undefined ? _data["serviceTypeId"] : <any>null;
        }
    }

    static fromJS(data: any): AddInventoryItemServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddInventoryItemServiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servicedAt"] = this.servicedAt ? this.servicedAt.toISOString() : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["serviceTypeId"] = this.serviceTypeId !== undefined ? this.serviceTypeId : <any>null;
        return data; 
    }
}

export interface IAddInventoryItemServiceRequest {
    servicedAt: moment.Moment;
    description?: string | null;
    serviceTypeId: string;
}

export class InventoryItemServiceResponse implements IInventoryItemServiceResponse {
    servicedAt!: moment.Moment;
    servicedById!: string;
    description?: string | null;
    serviceTypeName!: string;

    constructor(data?: IInventoryItemServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servicedAt = _data["servicedAt"] ? moment(_data["servicedAt"].toString()) : <any>null;
            this.servicedById = _data["servicedById"] !== undefined ? _data["servicedById"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.serviceTypeName = _data["serviceTypeName"] !== undefined ? _data["serviceTypeName"] : <any>null;
        }
    }

    static fromJS(data: any): InventoryItemServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servicedAt"] = this.servicedAt ? this.servicedAt.toISOString() : <any>null;
        data["servicedById"] = this.servicedById !== undefined ? this.servicedById : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["serviceTypeName"] = this.serviceTypeName !== undefined ? this.serviceTypeName : <any>null;
        return data; 
    }
}

export interface IInventoryItemServiceResponse {
    servicedAt: moment.Moment;
    servicedById: string;
    description?: string | null;
    serviceTypeName: string;
}

export class LoanHistoryLendingPeriodResponse implements ILoanHistoryLendingPeriodResponse {
    loanedOutToType!: LoanedOutToType;
    loanedOutToId?: string | null;
    startDate!: moment.Moment;
    createdAt!: moment.Moment;
    endDate?: moment.Moment | null;
    endedAt?: moment.Moment | null;
    isActive!: boolean;
    accessoryDescription?: string | null;

    constructor(data?: ILoanHistoryLendingPeriodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanedOutToType = _data["loanedOutToType"] !== undefined ? _data["loanedOutToType"] : <any>null;
            this.loanedOutToId = _data["loanedOutToId"] !== undefined ? _data["loanedOutToId"] : <any>null;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>null;
            this.endedAt = _data["endedAt"] ? moment(_data["endedAt"].toString()) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.accessoryDescription = _data["accessoryDescription"] !== undefined ? _data["accessoryDescription"] : <any>null;
        }
    }

    static fromJS(data: any): LoanHistoryLendingPeriodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoanHistoryLendingPeriodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanedOutToType"] = this.loanedOutToType !== undefined ? this.loanedOutToType : <any>null;
        data["loanedOutToId"] = this.loanedOutToId !== undefined ? this.loanedOutToId : <any>null;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : <any>null;
        data["endedAt"] = this.endedAt ? this.endedAt.toISOString() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["accessoryDescription"] = this.accessoryDescription !== undefined ? this.accessoryDescription : <any>null;
        return data; 
    }
}

export interface ILoanHistoryLendingPeriodResponse {
    loanedOutToType: LoanedOutToType;
    loanedOutToId?: string | null;
    startDate: moment.Moment;
    createdAt: moment.Moment;
    endDate?: moment.Moment | null;
    endedAt?: moment.Moment | null;
    isActive: boolean;
    accessoryDescription?: string | null;
}

export class InventoryItemWithLatestLendingPeriodForResidentResponse implements IInventoryItemWithLatestLendingPeriodForResidentResponse {
    id!: string;
    productName!: string;
    productTypeName!: string;
    productCategoryName!: string;
    assignedId!: string;
    accessControlTagIds!: string[];
    latestLendingPeriod!: LoanHistoryLendingPeriodResponse;

    constructor(data?: IInventoryItemWithLatestLendingPeriodForResidentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
            this.latestLendingPeriod = new LoanHistoryLendingPeriodResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
            this.productTypeName = _data["productTypeName"] !== undefined ? _data["productTypeName"] : <any>null;
            this.productCategoryName = _data["productCategoryName"] !== undefined ? _data["productCategoryName"] : <any>null;
            this.assignedId = _data["assignedId"] !== undefined ? _data["assignedId"] : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.latestLendingPeriod = _data["latestLendingPeriod"] ? LoanHistoryLendingPeriodResponse.fromJS(_data["latestLendingPeriod"]) : new LoanHistoryLendingPeriodResponse();
        }
    }

    static fromJS(data: any): InventoryItemWithLatestLendingPeriodForResidentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemWithLatestLendingPeriodForResidentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        data["productTypeName"] = this.productTypeName !== undefined ? this.productTypeName : <any>null;
        data["productCategoryName"] = this.productCategoryName !== undefined ? this.productCategoryName : <any>null;
        data["assignedId"] = this.assignedId !== undefined ? this.assignedId : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["latestLendingPeriod"] = this.latestLendingPeriod ? this.latestLendingPeriod.toJSON() : <any>null;
        return data; 
    }
}

export interface IInventoryItemWithLatestLendingPeriodForResidentResponse {
    id: string;
    productName: string;
    productTypeName: string;
    productCategoryName: string;
    assignedId: string;
    accessControlTagIds: string[];
    latestLendingPeriod: LoanHistoryLendingPeriodResponse;
}

export class DeleteInventoryItemRequest implements IDeleteInventoryItemRequest {
    reason!: string;

    constructor(data?: IDeleteInventoryItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteInventoryItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInventoryItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        return data; 
    }
}

export interface IDeleteInventoryItemRequest {
    reason: string;
}

export class CreateInventoryItemSourceRequest implements ICreateInventoryItemSourceRequest {
    name!: string;

    constructor(data?: ICreateInventoryItemSourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateInventoryItemSourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInventoryItemSourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface ICreateInventoryItemSourceRequest {
    name: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}